import React from 'react'
import { CloseOutlined as CloseIcon } from '@material-ui/icons';
import { Alert, AlertIcon, AlertDescription, Link } from '@chakra-ui/react'
import * as AppConstants from 'Constants/index'
import styled from 'styled-components'

const StyledAlertIcon = styled(AlertIcon)`
    max-width: 18px;
    margin-right: 5px;
`

export default function AlertHashTransaction({
    transactionInfo,
    closeTransactionHash,
}) {
    const { transactionHash, status } = transactionInfo
    const shortTransactionHash = `${transactionHash?.substr(0, 6)}...${transactionHash?.substr(
        transactionHash.length - 6,
        transactionHash.length - 1
    )}`

    const onClickTransactionHash = () => {
        closeTransactionHash()
    }

    return (
        <Alert status={status ? 'success' : 'error'} p="5px 8px" borderRadius="5px">
            <StyledAlertIcon />
            <AlertDescription>
                <Link href={`${AppConstants.BSC_SCAN_HASH_URL}${transactionHash}`} isExternal>
                    View transaction on BSCScan: {shortTransactionHash}
                </Link>
            </AlertDescription>

            <CloseIcon
                onClick={onClickTransactionHash}
                cursor="pointer"
                position="absolute"
                right="8px"
                top="8px"
            />
        </Alert>
    )
}
